module.exports = __webpack_public_path__ + "img/1.7ef788f3.jpg";